import React from "react";
import { IndexTable } from "@shopify/polaris";
import HorseVariant from "../../common/HorseVariant/HorseVariant";
import { assertString } from "../../../helper_functions/utils";
import { TextField } from "@shopify/polaris";
import { formatMoney } from "../../../helper_functions/utils";
import type { IPurchaseOrder, IPurchaseOrderLineItem } from "../../../api_utils/types";

export default function PurchaseOrderOrderedRow({
  purchaseOrderLineItem,
  index,
  purchaseOrder,
  originalPoli,
  handleLineItemQuantityChange,
}: {
  readonly purchaseOrderLineItem: IPurchaseOrderLineItem,
  readonly originalPoli: IPurchaseOrderLineItem,
  readonly index: number,
  readonly purchaseOrder: IPurchaseOrder,
  readonly handleLineItemQuantityChange: (mLabel: string, id: number) => (newQuantity?: string) => void,
}): React.ReactElement {
  const isDirty = originalPoli.received !== purchaseOrderLineItem.received;

  let className: string | undefined = undefined;
  if (!isDirty) {
    className = undefined;
  } else if (purchaseOrderLineItem.received > purchaseOrderLineItem.quantity || purchaseOrderLineItem.received < purchaseOrderLineItem.quantity) {
    className = "receiving-warning";
  }
  let errorMessage: string | undefined = undefined;
  if (!isDirty) {
    errorMessage = undefined;
  } else if (purchaseOrderLineItem.received > purchaseOrderLineItem.quantity) {
    errorMessage = "Received greater than ordered";
  } else if (purchaseOrderLineItem.received < purchaseOrderLineItem.quantity) {
    errorMessage = "Received less than ordered";
  }

  return (
    <IndexTable.Row id={purchaseOrderLineItem.id.toString()} key={purchaseOrderLineItem.id} position={index + 1}>
      <IndexTable.Cell>
        <div className="medium_hv">
          <HorseVariant key={purchaseOrderLineItem.id} variant={purchaseOrderLineItem} />
        </div>
      </IndexTable.Cell>
      {/* <IndexTable.Cell>
        <div className='w120'>
          <TextField
            onChange={handleLineItemChange('entry_summary_line_number', purchaseOrderLineItem.id)}
            id={purchaseOrderLineItem.id}
            key={purchaseOrderLineItem.id}
            type='integer'
            name='entry_summary_line_number'
            value={assertString(purchaseOrderLineItem?.entry_summary_line_number)}
          />
        </div>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <div className='w120'>
          <TextField
            onChange={handleLineItemChange('description_of_goods', purchaseOrderLineItem.id)}
            id={purchaseOrderLineItem.id}
            key={purchaseOrderLineItem.id}
            name='description_of_goods'
            value={purchaseOrderLineItem?.description_of_goods}
          />
        </div>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <TextField
          onChange={handleLineItemChange('classification_number', purchaseOrderLineItem.id)}
          id={purchaseOrderLineItem.id}
          key={purchaseOrderLineItem.id}
          name='classification_number'
          value={assertString(purchaseOrderLineItem?.classification_number)}
        />
      </IndexTable.Cell>
      <IndexTable.Cell>
        <div className='w120'>
          <TextField
            onChange={handleLineItemChange('duty_rate', purchaseOrderLineItem.id)}
            id={purchaseOrderLineItem.id}
            key={purchaseOrderLineItem.id}
            name='duty_rate'
            suffix='%'
            type='number'
            value={assertString(polis[purchaseOrderLineItem.id]?.duty_rate)} />
        </div>
      </IndexTable.Cell> */}
      <IndexTable.Cell>{purchaseOrderLineItem.warehouse_location}</IndexTable.Cell>
      <IndexTable.Cell>
        {purchaseOrderLineItem.quantity}
      </IndexTable.Cell>
      <IndexTable.Cell>
        <div className={className} style={{ maxWidth: "120px" }}>
          <TextField
            autoComplete="off"
            error={errorMessage}
            id={purchaseOrderLineItem.id.toString()}
            inputMode="numeric"
            key={purchaseOrderLineItem.id}
            label=""
            labelHidden
            name="received"
            onChange={handleLineItemQuantityChange("received", purchaseOrderLineItem.id)}
            type="integer"
            value={assertString(purchaseOrderLineItem.received)}
          />
        </div>
      </IndexTable.Cell>
      <IndexTable.Cell>{formatMoney(purchaseOrderLineItem.cost, purchaseOrder.currency)}</IndexTable.Cell>
      {/* <IndexTable.Cell>
        {formatMoney(getDuties(purchaseOrderLineItem), purchaseOrder.currency)}
      </IndexTable.Cell> */}
      <IndexTable.Cell>
        {formatMoney(Number(purchaseOrderLineItem.quantity || 0) * Number(purchaseOrderLineItem.cost || 0), purchaseOrder.currency)}
      </IndexTable.Cell>
    </IndexTable.Row>);
};
